export default "__VITE_ASSET__BDYIsRHW__"